import { BaseService, Service } from "/@/cool";
@Service("sugSuggest")
class SugSuggest extends BaseService {}
export default SugSuggest;
